import Vue from 'vue'
import store from 'public/store'
import routes from './routes'
import bus from 'public/utils/bus'
import { getToken, setToken, defineFreezeProperty } from 'public/utils'
import { setMenuIdToComponent } from './tools.js'
import Router from 'vue-router'
import { loadModule, filterRoutes, initRemoteModule } from './remote/index.js'
import { recodeMenuOpenTime } from './helpers/recode-moudle-open-time.js'
import { setMultiModuleData } from '../utils/index.js'
Vue.use(Router)

let hasAddedRoutes = false

const checkAuth = (menus, tag, meta = {}) => {
  return !tag || !!menus[tag] || meta.authIgnore
}

const reduceCloseDialog = (vms, obj) => {
  vms.forEach(v => {
    reduceCloseDialog(v.$children, obj)
    if (
      v.visible &&
      v.$listeners['update:visible'] &&
      v.$el.className.indexOf('el-dialog__wrapper') > -1 &&
      v.$el.className.indexOf('kye-dialog__modal-in-tab') === -1
    ) {
      v.$emit('update:view', '')
      v.$emit('update:visible', false)
      obj.flag = true
    }
  })
}

const router = new Router({
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

const originPush = router.push
const originReplace = router.replace

function errorTips (e) {
  if (e && e.hasOwnProperty('name')) {
    console.warn('此项目禁止使用 name 跳转')
    return true
  }
  return false
}

function newPush (e) {
  if (!errorTips(e)) {
    originPush.apply(router, arguments)
  }
}

function newReplace (e) {
  if (!errorTips(e)) {
    originReplace.apply(router, arguments)
  }
}

// 外部应用携带token&query跳转erp
function externalClientOpen (to, next) {
  const newTo = { ...to, query: { ...to.query } }
  delete newTo.query.erpticket
  delete newTo.query.isExternal
  next(newTo)
}


// 新增route的replace语义化方法，解决返回的堆栈处理问题
function erpReplace (e) {
  if (!errorTips(e)) {
    const routePath = arguments[0]
    const route = router.resolve(routePath).route
    if (route && route.meta) {
      route.meta.erpReplace = true
    }
    originReplace.apply(router, arguments)
  }
}

if (process.env.NODE_ENV !== 'production') {
  router.push = newPush
  router.replace = newReplace
}

router.erpReplace = erpReplace

router.beforeEach((to, from, next) => {
  let menu = store.getters.menus[to.meta.tag]
  recodeMenuOpenTime(menu)
  if (!menu) {
    menu = window.__ERPMODULE__
  }
  defineFreezeProperty(window, '__ERPMODULE__', menu ? JSON.parse(JSON.stringify(menu)) : {})
  // 路由离开前如果有未关闭的模态框，则关闭模态框并终止导航
  let $children = from.matched[1] && from.matched[1].instances.default && from.matched[1].instances.default.$children
  if ($children && $children.length) {
    let needClose = { flag: false }
    reduceCloseDialog($children, needClose)
    if (needClose.flag) {
      next(false)
      return
    }
  }

  if (to.path === '/error') {
    next()
    return
  }

  // 外部用户访问
  let token = to.query.erpticket
  if (token) {
    const isExternal = +to.query.isExternal // 是否外部应用访问(区分账号借用)
    if (isExternal !== 1) {
      token = window.atob(token)
    }
    window.__ERP__outsideAccount = true
    setToken(token)
    if (isExternal) {
      externalClientOpen(to, next)
      return
    }
  } else {
    token = getToken()
  }
  if (token && to.path === '/login') {
    next(false)
    return
  }
  // 获取携带的泳道信息
  const multiModules = to.query.multiModules
  if (multiModules) {
    setMultiModuleData(JSON.parse(multiModules))
  }

  from.meta.layout = false

  if (token) {
    if (store.getters.menus.menuTree) {
      if (checkAuth(store.getters.menus, to.meta.tag, to.meta)) {
        loadModule(to, next, router)
      } else {
        // 路由跳转没权限的场景，需要在403页面展示需要跳转模块的模块名
        next({ name: 'error403', replace: true, params: { to } })
      }
    } else {
      // 首页不等待菜单接口加载完成
      if (to.path === '/') {
        next()
      }
      // 先加载所有初始化数据(权限code/菜单/个人信息), 再动态添加业务线的路由
      store.dispatch('getGlobalData').then(() => {
        if (checkAuth(store.getters.menus, to.meta.tag)) {
          // 动态添加业务线的路由
          if (!hasAddedRoutes) {
            import(/* webpackChunkName: "public-route" */ './chunk.js').then(res => {
              console.log('addRoutes-auth')
              hasAddedRoutes = true
              router.addRoutes(filterRoutes(res.default))
              bus.$emit('APP_LOADED')
              if (to.path !== '/') {
                next({ ...to })
              }
            }).catch(_ => {
              console.error('import all chunks: ', _)
              if (to.path !== '/') {
                next({ path: '/403', replace: true })
              }
            })
          } else {
            bus.$emit('APP_LOADED')
            next()
          }
        } else {
          // 动态添加业务线的路由
          if (!hasAddedRoutes) {
            import(/* webpackChunkName: "public-route" */ './chunk.js').then(res => {
              console.log('addRoutes-noauth')
              hasAddedRoutes = true
              router.addRoutes(filterRoutes(res.default))
              bus.$emit('APP_LOADED')
            })
          } else {
            bus.$emit('APP_LOADED')
          }
          next({ path: '/403', replace: true })
        }
      }).catch(e => {
        console.error('getGlobalData: ', e)
        let query = e ? { type: e.type, key: e.key } : {}
        next({ path: '/error', query, replace: true })
        window._apm && window._apm('captureException', new Error(`【ERP:getGlobalData-error】${e}`))
      })
    }
  } else {
    if (to.path === '/login') {
      next()
    } else {
      // 无Token时，且不是登录页面，则存储URL路由全路径到store，存在ERPCacheFlag（即登录过铸剑系统）且登录成功，则会重定向到该路由
      store.dispatch('setOldPath', {
        oldPath: to.fullPath
      })
      next('/login')
    }
  }
})
router.beforeResolve((to, from, next) => {
  try {
    setMenuIdToComponent(to)
  } catch (error) {
    console.log(error)
  }
  next()
})

let sharedRouter = null

if (window.__ERP_PUBLIC_SHARED_ROUTER__) {
  sharedRouter = window.__ERP_PUBLIC_SHARED_ROUTER__
} else { // 主包
  window.__ERP_PUBLIC_SHARED_ROUTER__ = sharedRouter = router
  initRemoteModule(router)
}

export default sharedRouter



// WEBPACK FOOTER //
// ./src/layout/router/index.js